import { Core_SimpleHealthInsuranceType } from '@/generated/graphql';

import { useEnumFormatter } from './useEnumFormatter';

const SimpleHealthInsuranceTypeTitles: Partial<Record<Core_SimpleHealthInsuranceType, string>> = {
  [Core_SimpleHealthInsuranceType.SimpleHealthInsuranceTypeNone]: 'insurance-type.none',
  [Core_SimpleHealthInsuranceType.SimpleHealthInsuranceTypePublic]: 'insurance-type.public',
  [Core_SimpleHealthInsuranceType.SimpleHealthInsuranceTypePrivate]: 'insurance-type.private',
};

export function useSimpleHealthInsuranceTypeFormatter() {
  return {
    formatSimpleHealthInsuranceType: useEnumFormatter<Core_SimpleHealthInsuranceType>(
      SimpleHealthInsuranceTypeTitles,
    ),
    SimpleHealthInsuranceTypeTitles,
  };
}
